import React from "react";
// import css from "./BookingCard.module.css";
import "./BookingCard.css";
import { useAgent } from "contexts/v1/masterData/AgentContext";
import { useLabel } from "contexts/v1/masterData/LabelContext";

const BookingCard = ({ booking, session, onClick }) => {
  const { agents } = useAgent();
  // console.log("agent", agents);
  const { labels } = useLabel();
  // console.log("label", labels);

  const getLabelById = (labelId) => {
    return labels.data.find((l) => l.id === labelId) || null;
  };

  const label = getLabelById(booking.label_id);

  // Helper function to get agent data by id
  const getAgentById = (agentId) => {
    return agents.data.find((a) => a.id === agentId) || null; // Kembalikan seluruh data agent
  };

  // Dapatkan data agent berdasarkan booking.agent_id
  const agent = getAgentById(booking.agent_id);

  return (
    <div
      className={`card bg-${booking?.status === "cancelled" ? "muted" : "light"}
        text-dark card-body px-3 py-2 cursor-pointer h-100 booking-card`}
      // className={`card ${booking?.agent?.color} text-dark card-body px-3 py-2 cursor-pointer h-100 booking-card`}
      onClick={() => onClick(booking)}
      style={{
        borderLeft: `16px solid ${agent?.color || "light"}`, // Warna agent digunakan sebagai border
      }}
    >
      {/* <div className="ribbon bg-red">{booking?.guest_transport}</div> */}
      <div
        className={`ribbon bg-${
          booking.guest_transport === "OT"
            ? "red"
            : booking.guest_transport === "PU"
            ? "green"
            : booking.guest_transport === "P"
            ? "yellow"
            : booking.guest_transport === "D"
            ? "blue"
            : "dark"
        }`} // Warna berdasarkan status
        title="Transport"
      >
        <b>{booking.guest_transport}</b>
      </div>
      {/* <span
        className={`badge bg-${
          booking.status === "waiting"
            ? "yellow-lt"
            : booking.status === "confirmed"
            ? "green-lt"
            : "dark"
        } text-uppercase`} // Warna berdasarkan status
        title="Status Booking"
      >
        <b>{booking.status}</b>
      </span> */}
      {/* Status :
 { value: "book", label: "Book" },
    { value: "re-confirm", label: "Re Confirm" },
    { value: "confirmed", label: "Confirmed" },
    { value: "playing", label: "Playing" },
    { value: "finish", label: "Finish" },
    { value: "cancel", label: "Cancel" }, */}
      <span
        className={`badge bg-${
          booking.status === "booked"
            ? "yellow-lt"
            : booking.status === "reconfirmed"
            ? "blue-lt"
            : booking.status === "confirmed"
            ? "green-lt"
            : booking.status === "played"
            ? "purple-lt"
            : booking.status === "finished"
            ? "success-lt"
            : "dark"
        } text-uppercase`} // Warna berdasarkan status
        title="Status Booking"
      >
        <b>{booking.status}</b>
      </span>

      {/* </div> */}
      {/* Booking ID */}
      <div className="h3 mb-1 fs-4" title="Kode Booking">
        {booking.code}
      </div>
      <div className="d-flex align-items-center gap-1">
        <div className="d-flex align-items-center gap-1">
          <span className="d-flex align-items-center fs-6 icon" title="Person">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
              />
            </svg>
            <span>{booking.guest_pax}</span>
          </span>
        </div>
        <span
          title={booking?.guest_name}
          className="fs-6 text-truncate" // Font size kecil + potong teks panjang
        >
          {booking?.guest_name?.length > 15
            ? booking?.guest_name?.substring(0, 10) + "..."
            : booking?.guest_name}
        </span>
      </div>

      {/* Capacity and Location */}
      <div className="d-flex align-items-center gap-2 mb-1">
        <div className="d-flex align-items-center gap-1">
          <span className="d-flex align-items-center fs-6 icon" title="Bike">
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              height="0.5em"
              width="0.5em"
              className="icon"
            >
              <path d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4l2 2h3l3.5-6.1 1 1c-.9.7-1.5 1.9-1.5 3.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
            </svg>
            <span>{booking.qty_product_activities}</span>
          </span>
        </div>

        <div className="d-flex align-items-center gap-1">
          <span className="d-flex align-items-center fs-5">
            <svg
              viewBox="0 0 640 512"
              fill="currentColor"
              height="0.5em"
              width="0.5em"
              className="icon me-1"
            >
              <path d="M506.1 127.1c-17.97-20.17-61.46-61.65-122.7-71.1-22.5-3.354-45.39 3.606-63.41 18.21C302 60.47 279.1 53.42 256.5 56.86c-79.7 12.31-129.8 79.34-131.9 82.24-7.844 10.69-5.531 25.72 5.125 33.57a23.858 23.858 0 0014.19 4.657c7.406 0 14.69-3.375 19.38-9.782.406-.563 40.19-53.91 100.5-63.23 7.457-.961 14.98.67 21.56 4.483L227.2 168.2c-12.4 12.3-20.1 27.9-20.1 46.3 0 17.5 6.812 33.94 19.16 46.29 13.24 12.41 29.64 18.31 47.14 18.31s33.94-6.813 46.31-19.19l11.35-11.35 124.2 100.9c2.312 1.875 2.656 5.251.5 7.97l-27.69 35.75c-1.844 2.25-5.25 2.594-7.156 1.063l-22.22-18.69-26.19 27.75c-2.344 2.875-5.344 3.563-6.906 3.719-1.656.156-4.562.125-6.812-1.719l-32.41-27.66L310.7 392.3l-2.812 2.938c-5.844 7.157-14.09 11.66-23.28 12.6-9.469.813-18.25-1.75-24.5-6.782L170.3 319.8H96V128.3H0v255.6l64 .04c11.74 0 21.57-6.706 27.14-16.14h60.64l77.06 69.66C243.7 449.6 261.9 456 280.8 456c2.875 0 5.781-.125 8.656-.438 13.62-1.406 26.41-6.063 37.47-13.5l.906.813c12.03 9.876 27.28 14.41 42.69 12.78 13.19-1.375 25.28-7.032 33.91-15.35 21.09 8.188 46.09 2.344 61.25-16.47l27.69-35.75c18.47-22.82 14.97-56.48-7.844-75.01l-120.3-97.76 8.381-8.382c9.375-9.376 9.375-24.57 0-33.94-9.375-9.376-24.56-9.376-33.94 0L285.8 226.8c-6.6 6.7-18.1 6.7-24.7 0-3.312-3.282-5.125-7.657-5.125-12.31 0-4.688 1.812-9.064 5.281-12.53l85.91-87.64c7.812-7.845 18.53-11.75 28.94-10.03 59.75 9.22 100.2 62.73 100.6 63.29 3.088 4.155 7.264 6.946 11.84 8.376H544v175.1c0 17.67 14.33 32.05 31.1 32.05L640 384V128.1l-133.9-1zM48 352c-8.75 0-16-7.245-16-15.99 0-8.876 7.25-15.99 16-15.99s16 7.18 16 16.08c0 8.7-7.25 15.9-16 15.9zm544 0c-8.75 0-16-7.245-16-15.99 0-8.876 7.25-15.99 16-15.99s16 7.117 16 15.99c0 8.79-7.2 15.99-16 15.99z" />
            </svg>
            <span title="Agent Name">
              {/* {getAgentNameById(booking.agent_id)} */}
              {agent?.name || "Unknown Agent"}
            </span>
            {/* <span title={booking?.agent_id} className="text-truncate">
              {booking?.agent_id?.length > 15
                ? booking?.agent_id.substring(0, 10) + "..."
                : booking?.agent_id}
            </span> */}
            {/* <span title={booking?.agent?.name} className="text-truncate">
              {booking?.agent?.name?.length > 15
                ? booking?.agent?.name.substring(0, 10) + "..."
                : booking?.agent?.name}
            </span> */}
          </span>
        </div>
      </div>
      {/* label */}
      {label && (
        <span
          // Gunakan bg color dari label
          className="badge fs-6"
          style={{
            backgroundColor: label.color || "#ccc", // Warna background dari label.color, fallback ke #ccc jika undefined
            color: "#fff", // Pastikan teks terlihat dengan warna putih
          }}
          title="Status Booking"
        >
          <b>{label.name}</b>
        </span>
      )}
    </div>
  );
};

export default BookingCard;
